import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-semibold text-xl"
}

import { Component as VueComponent, computed } from "vue";
import { DashboardGridSize } from "@/types/Dashboard";
import { Report, ReportPlotType, ReportSummary } from "@/types/Report";
import CycleTimesPlot from "@/views/reports/plots/CycleTimesPlot.vue";
import MilestonePlot from "@/views/reports/plots/MilestonePlot.vue";
import UnitValuesPlot from "@/views/reports/plots/UnitValuesPlot.vue";
import WorkingHourCurvePlot from "@/views/reports/plots/WorkingHourCurvePlot.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportPlot',
  props: {
    report: {},
    data: {},
    title: {},
    hidePopover: { type: Boolean },
    width: {},
    height: {},
    hideLegend: { type: Boolean },
    spacingX: {},
    spacingY: {},
    dashboardGridSize: {}
  },
  setup(__props: any) {

const widgets: Record<ReportPlotType, VueComponent> = {
  cycle_times: CycleTimesPlot,
  working_hour_curve: WorkingHourCurvePlot,
  unit_values: UnitValuesPlot,
  milestone: MilestonePlot,
};

const props = __props;

const propsToBind = computed(() => {
  const { report, ...rest } = props;
  return rest;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(widgets[_ctx.report.plot.type]), _mergeProps(propsToBind.value, {
      reportId: _ctx.report._id,
      filters: _ctx.report.filters,
      config: _ctx.report.plot.config
    }), null, 16, ["reportId", "filters", "config"])),
    (_ctx.data && !Object.keys(_ctx.data).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("analytics.reports.no_data")), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})